import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { get } from "lodash";
import { push } from "react-router-redux";
import { shortDate } from "LIB/formatters/date";
import { getFirstNameLastInitial, truncate } from "LIB/formatters/text";
import { dollars } from "LIB/formatters/currency";
import PurchaseOrderLineItemStatusCell from "MODULES/shared/components/PurchaseOrderLineItemStatusCell";
import { NoteTooltipTableCell } from "MODULES/shared/components/NoteTooltip";
import {
  DataTable,
  SearchPropTypes,
  CompanyName,
  LineItemQtyCell,
  LinkedTableRow
} from "MODULES/shared/components";
import { AsIsFlag } from "MODULES/IncomingQuotes/shared/AsIsFlag";
import { ExchangeIcon } from "MODULES/PurchaseOrders/shared/ExchangeIcon";
import { displayCost } from "MODULES/PurchaseOrders/shared/helpers";
import { INVENTORIES } from "MODULES/inventories/constants";

function renderRow(lineItem, i) {
  const handleMailto = e => {
    e.stopPropagation();
  };

  const link = (type, uuid) => {
    if (type === "PurchaseOrder") {
      return `/purchase-orders/${uuid}`;
    } else if (type === "Lot") {
      return `/lots/${uuid}`;
    }

    return null;
  };

  return (
    <LinkedTableRow
      to={link(lineItem.type, lineItem.parent_uuid)}
      key={i}
      cancelled={lineItem.cancelled}
    >
      <td>
        <div style={{ whiteSpace: "nowrap" }}>
          <div style={{ textAlign: "right" }}>
            <LineItemQtyCell lineItem={lineItem} />
            {i + 1}
          </div>
        </div>
      </td>
      <PurchaseOrderLineItemStatusCell lineItem={lineItem}>
        <td>{lineItem.code}</td>
      </PurchaseOrderLineItemStatusCell>
      <td> {shortDate(lineItem.created_at)}</td>
      <td>
        <CompanyName flattenedCompany={lineItem} />
      </td>
      <td>{getFirstNameLastInitial(lineItem.buyer_name)}</td>
      <td>
        {lineItem.co_buyer_name &&
          getFirstNameLastInitial(lineItem.co_buyer_name)}
      </td>
      <td>{lineItem.serial_number || lineItem.expected_serial_number}</td>
      <td>{truncate(get(lineItem, "contact_name", 25))}</td>
      <td>
        {lineItem.contact_email && (
          <a
            href={`mailto:${get(lineItem, "contact_email")}`}
            onClick={handleMailto}
          >
            {get(lineItem, "contact_email")}
          </a>
        )}
      </td>
      <td>
        {lineItem.condition && INVENTORIES.condition[lineItem.condition].abbrev}
        <AsIsFlag lineItem={lineItem} className="m-l-5" />
      </td>
      <td>{lineItem.quantity}</td>
      <td className="text-center">{lineItem.quantity_received}</td>
      <td className="text-center">
        <ExchangeIcon lineItem={lineItem} />
      </td>
      <td>{lineItem.lead_time}</td>
      <td className="text-right">
        {displayCost(lineItem) && dollars(displayCost(lineItem))}
      </td>
      <td className="text-right">
        {lineItem.purchase_for_exchange &&
          !lineItem.outright &&
          dollars(lineItem.cost)}
      </td>
      <td className="text-right">{dollars(lineItem.subtotal)}</td>
      <NoteTooltipTableCell note={lineItem.internal_note} />
    </LinkedTableRow>
  );
}

export function Table(props) {
  const { pushHistory, isLoading, results } = props;

  return (
    <DataTable loading={isLoading} numbered>
      <DataTable.Head>
        <th />
        <th>PO #</th>
        <th>Date Created</th>
        <th>Vendor</th>
        <th>Buyer</th>
        <th>Co-Buyer</th>
        <th>Serial #</th>
        <th>Contact</th>
        <th>Email</th>
        <th>CD</th>
        <th>QTY</th>
        <th className="text-center">QTY Rec</th>
        <th className="text-center">Exch</th>
        <th>LT</th>
        <th className="text-right">Exch Fee/Cost Ea</th>
        <th className="text-right">Outright Value</th>
        <th className="text-right">Total</th>
        <th />
      </DataTable.Head>
      <DataTable.Body>
        {results.map((r, i) => renderRow(r, i, pushHistory))}
      </DataTable.Body>
    </DataTable>
  );
}

Table.propTypes = {
  pushHistory: PropTypes.func.isRequired,
  ...SearchPropTypes
};

export default connect(undefined, { pushHistory: push })(Table);



// WEBPACK FOOTER //
// ./app/modules/parts/components/PurchaseOrderLineItems/Table.jsx